/**
 * frontend/src/components/common/SEO.js
 * 
 * Component for managing search engine optimization (SEO) metadata using React Helmet.
 * It dynamically updates the page title, description, keywords, and Open Graph tags.
 */
import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'ChangeFox - Compliance Change Management Platform',
  description = 'Streamline your compliance change management with ChangeFox. Track requests, manage approvals, and maintain complete audit trails - all in one intuitive platform.',
  keywords = 'compliance, change management, audit trail, change requests, approval workflow, compliance software',
  path = '/',
  type = 'website',
}) => {
  const baseUrl = 'https://changefox.ai';
  const url = `${baseUrl}${path}`;
  const imageUrl = `${baseUrl}/og-image.png`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="ChangeFox" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
};

export default SEO;
